import React from "react";
import PropTypes from "prop-types";

import { Header, Icon, Segment, SegmentGroup } from "semantic-ui-react";

const conditionStatuses = {
  UNKNOWN: {
    icon: {
      name: "filter",
      foregroundColor: "#FFFFFF",
    },
    color: "#FFA500",
  },
  TRUE: {
    icon: {
      name: "check",
      foregroundColor: "#FFFFFF",
    },
    color: "#21ba45",
  },
  FALSE: {
    icon: {
      name: "close",
      foregroundColor: "#FFFFFF",
    },
    color: "#db2828",
  },
};

function ConditionalNextWorkflowsTile({ nextWorkflows }) {
  if (!nextWorkflows.length) {
    return null;
  }

  const { conditionStatus } = nextWorkflows[0];

  return (
    <div
      data-test="conditional-next-workflow-tile"
      style={{ position: "relative" }}
    >
      <Icon
        name={conditionStatuses[conditionStatus].icon.name}
        circular
        size="tiny"
        data-test="conditional-next-workflow-tile-icon"
        style={{
          position: "absolute",
          left: "-6px",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 1,
          backgroundColor: conditionStatuses[conditionStatus].color,
          color: conditionStatuses[conditionStatus].icon.foregroundColor,
        }}
      />

      <SegmentGroup
        data-test="conditional-next-workflow-tile-segment"
        style={{
          margin: "0.25em 0em",
          padding: "0.5em 1em",
          borderColor: conditionStatuses[conditionStatus].color,
          boxShadow: `0px 1px 2px 0 ${conditionStatuses[conditionStatus].color}`,
        }}
      >
        {nextWorkflows.map((nw) => {
          return (
            <Segment key={nw.id} style={{ margin: "0", padding: "0.5em 0em" }}>
              <Header
                title={nw.nextWorkflowName}
                as="h5"
                className="overflow_ellipsis"
                style={{ color: "grey" }}
              >
                {nw.nextWorkflowName}
              </Header>
            </Segment>
          );
        })}
      </SegmentGroup>
    </div>
  );
}

ConditionalNextWorkflowsTile.propTypes = {
  nextWorkflows: PropTypes.arrayOf(
    PropTypes.shape({
      nextWorkflowName: PropTypes.string.isRequired,
      conditionStatus: PropTypes.oneOf(["UNKNOWN", "TRUE", "FALSE"]).isRequired,
    })
  ),
};

ConditionalNextWorkflowsTile.defaultProps = { nextWorkflows: [] };

export default ConditionalNextWorkflowsTile;
